import { render, staticRenderFns } from "./TableGenderBrothersBySpecimen.vue?vue&type=template&id=73cfdfe2"
import script from "./TableGenderBrothersBySpecimen.vue?vue&type=script&lang=js"
export * from "./TableGenderBrothersBySpecimen.vue?vue&type=script&lang=js"
import style0 from "./TableGenderBrothersBySpecimen.vue?vue&type=style&index=0&id=73cfdfe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports